"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _uuid = require("uuid");

var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));

var _DropdownMenu = _interopRequireDefault(require("./DropdownMenu"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var upArrowIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7 14l5-5 5 5z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}));

var downArrowIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7 10l5 5 5-5z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}));

var useWidth = function useWidth(target) {
  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useEffect)(function () {
    if (target != null) {
      setWidth(target.getBoundingClientRect().width);
      var triggerObserver = new ResizeObserver(function (entries) {
        var rect = entries[0].target.getBoundingClientRect();
        setWidth(rect === null || rect === void 0 ? void 0 : rect.width);
      });
      triggerObserver.observe(target);
      return function () {
        triggerObserver.unobserve(target);
      };
    }
  }, [target]);
  return width;
};

var DxcDropdown = function DxcDropdown(_ref) {
  var options = _ref.options,
      _ref$optionsIconPosit = _ref.optionsIconPosition,
      optionsIconPosition = _ref$optionsIconPosit === void 0 ? "before" : _ref$optionsIconPosit,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? "before" : _ref$iconPosition,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$caretHidden = _ref.caretHidden,
      caretHidden = _ref$caretHidden === void 0 ? false : _ref$caretHidden,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$expandOnHover = _ref.expandOnHover,
      expandOnHover = _ref$expandOnHover === void 0 ? false : _ref$expandOnHover,
      onSelectOption = _ref.onSelectOption,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fitContent" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState3 = (0, _react.useState)("trigger-".concat((0, _uuid.v4)())),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
      triggerId = _useState4[0];

  var menuId = "menu-".concat(triggerId);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isOpen = _useState6[0],
      changeIsOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      visualFocusIndex = _useState8[0],
      setVisualFocusIndex = _useState8[1];

  var colorsTheme = (0, _useTheme["default"])();
  var triggerRef = (0, _react.useRef)(null);
  var menuRef = (0, _react.useRef)(null);
  var width = useWidth(triggerRef.current);

  var handleOnOpenMenu = function handleOnOpenMenu() {
    changeIsOpen(true);
  };

  var handleOnCloseMenu = function handleOnCloseMenu() {
    changeIsOpen(false);
    setVisualFocusIndex(0);
  };

  var handleMenuItemOnClick = (0, _react.useCallback)(function (value) {
    var _triggerRef$current;

    onSelectOption(value);
    handleOnCloseMenu();
    (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
  }, [onSelectOption]);

  var handleOnBlur = function handleOnBlur(event) {
    !event.currentTarget.contains(event.relatedTarget) && handleOnCloseMenu();
  };

  var handleTriggerOnClick = function handleTriggerOnClick() {
    changeIsOpen(function (isOpen) {
      return !isOpen;
    });
  };

  var handleTriggerOnKeyDown = function handleTriggerOnKeyDown(event) {
    switch (event.key) {
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        setVisualFocusIndex(options.length - 1);
        handleOnOpenMenu();
        break;

      case " ":
      case "Down":
      case "ArrowDown":
      case "Enter":
        event.preventDefault();
        handleOnOpenMenu();
        break;
    }
  };

  var setPreviousIndexFocus = function setPreviousIndexFocus() {
    setVisualFocusIndex(function (currentFocusIndex) {
      var index = currentFocusIndex === 0 ? options.length - 1 : currentFocusIndex - 1;
      return index;
    });
  };

  var setNextIndexFocus = function setNextIndexFocus() {
    setVisualFocusIndex(function (currentFocusIndex) {
      var index = currentFocusIndex === options.length - 1 ? 0 : currentFocusIndex + 1;
      return index;
    });
  };

  var handleMenuOnKeyDown = (0, _react.useCallback)(function (event) {
    var _triggerRef$current2, _triggerRef$current3;

    switch (event.key) {
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        setPreviousIndexFocus();
        break;

      case "Down":
      case "ArrowDown":
        event.preventDefault();
        setNextIndexFocus();
        break;

      case " ":
      case "Enter":
        event.preventDefault();
        handleMenuItemOnClick(options[visualFocusIndex].value);
        break;

      case "Esc":
      case "Escape":
        event.preventDefault();
        handleOnCloseMenu();
        (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.focus();
        break;

      case "Home":
      case "PageUp":
        event.preventDefault();
        setVisualFocusIndex(0);
        break;

      case "End":
      case "PageDown":
        event.preventDefault();
        setVisualFocusIndex(options.length - 1);
        break;

      case "Tab":
        handleOnCloseMenu();
        (_triggerRef$current3 = triggerRef.current) === null || _triggerRef$current3 === void 0 ? void 0 : _triggerRef$current3.focus();
        break;
    }
  }, [onSelectOption, visualFocusIndex, options]);
  (0, _react.useLayoutEffect)(function () {
    var _menuRef$current, _visualFocusedMenuIte;

    var visualFocusedMenuItem = menuRef === null || menuRef === void 0 ? void 0 : (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.querySelectorAll("[role='menuitem']")[visualFocusIndex];
    visualFocusedMenuItem === null || visualFocusedMenuItem === void 0 ? void 0 : (_visualFocusedMenuIte = visualFocusedMenuItem.scrollIntoView) === null || _visualFocusedMenuIte === void 0 ? void 0 : _visualFocusedMenuIte.call(visualFocusedMenuItem, {
      block: "nearest",
      inline: "start"
    });
  }, [visualFocusIndex]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.dropdown
  }, /*#__PURE__*/_react["default"].createElement(DropdownContainer, {
    onMouseEnter: !disabled && expandOnHover ? handleOnOpenMenu : undefined,
    onMouseLeave: !disabled && expandOnHover ? handleOnCloseMenu : undefined,
    onBlur: !disabled ? handleOnBlur : undefined,
    margin: margin,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(Popover.Root, {
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(Popover.Trigger, {
    asChild: true,
    type: undefined
  }, /*#__PURE__*/_react["default"].createElement(DropdownTrigger, {
    opened: isOpen,
    onClick: handleTriggerOnClick,
    onKeyDown: handleTriggerOnKeyDown,
    onBlur: function onBlur(event) {
      event.stopPropagation();
    },
    disabled: disabled,
    label: label,
    margin: margin,
    size: size,
    id: triggerId,
    "aria-haspopup": "true",
    "aria-controls": menuId,
    "aria-expanded": isOpen ? true : undefined,
    tabIndex: tabIndex,
    ref: triggerRef
  }, /*#__PURE__*/_react["default"].createElement(DropdownTriggerContent, null, label && iconPosition === "after" && /*#__PURE__*/_react["default"].createElement(DropdownTriggerLabel, null, label), icon && /*#__PURE__*/_react["default"].createElement(DropdownTriggerIcon, {
    label: label,
    iconPosition: iconPosition,
    disabled: disabled,
    role: typeof icon === "string" ? undefined : "img"
  }, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement("img", {
    src: icon
  }) : icon), label && iconPosition === "before" && /*#__PURE__*/_react["default"].createElement(DropdownTriggerLabel, null, label)), !caretHidden && /*#__PURE__*/_react["default"].createElement(CaretIcon, {
    disabled: disabled
  }, isOpen ? upArrowIcon : downArrowIcon))), /*#__PURE__*/_react["default"].createElement(Popover.Content, {
    sideOffset: 1,
    asChild: true
  }, /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
    id: menuId,
    dropdownTriggerId: triggerId,
    options: options,
    iconsPosition: optionsIconPosition,
    visualFocusIndex: visualFocusIndex,
    menuItemOnClick: handleMenuItemOnClick,
    onKeyDown: handleMenuOnKeyDown,
    styles: {
      width: width
    },
    ref: menuRef
  })))));
};

var sizes = {
  small: "60px",
  medium: "240px",
  large: "480px",
  fillParent: "100%",
  fitContent: "fit-content"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var DropdownContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  width: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var DropdownTrigger = _styledComponents["default"].button(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  min-height: 40px;\n  min-width: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n\n  ", ";\n"])), function (props) {
  return props.theme.caretIconSpacing;
}, function (props) {
  return props.label === "" ? "0px" : calculateWidth(props.margin, props.size);
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderThickness;
}, function (props) {
  return props.theme.borderStyle;
}, function (props) {
  return props.disabled ? props.theme.disabledBorderColor : props.theme.borderColor;
}, function (props) {
  return props.theme.buttonPaddingTop;
}, function (props) {
  return props.theme.buttonPaddingBottom;
}, function (props) {
  return props.theme.buttonPaddingLeft;
}, function (props) {
  return props.theme.buttonPaddingRight;
}, function (props) {
  return props.disabled ? props.theme.disabledButtonBackgroundColor : props.theme.buttonBackgroundColor;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.buttonFontColor;
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return !props.disabled && "\n      &:focus {\n        outline: ".concat(props.theme.focusColor, " solid 2px;\n        outline-offset: -2px;\n      }\n      &:hover {\n        background-color: ").concat(props.theme.hoverButtonBackgroundColor, ";\n      }\n      &:active {\n        background-color: ").concat(props.theme.activeButtonBackgroundColor, ";\n      }\n  ");
});

var DropdownTriggerContent = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  margin-left: 0px;\n  margin-right: 0px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n"])), function (props) {
  return props.theme.buttonIconSpacing;
});

var DropdownTriggerLabel = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])), function (props) {
  return props.theme.buttonFontFamily;
}, function (props) {
  return props.theme.buttonFontSize;
}, function (props) {
  return props.theme.buttonFontStyle;
}, function (props) {
  return props.theme.buttonFontWeight;
});

var DropdownTriggerIcon = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.theme.buttonIconSize;
}, function (props) {
  return props.theme.buttonIconSize;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.buttonIconColor;
});

var CaretIcon = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  color: ", ";\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.caretIconColor;
}, function (props) {
  return props.theme.caretIconSize;
}, function (props) {
  return props.theme.caretIconSize;
});

var _default = DxcDropdown;
exports["default"] = _default;